import { FC } from "react"
import "./styles.scss"

interface IProps {
  title: string
  forModal?: boolean
  onClick?: () => void
  disabled?: boolean
}

export const RedButton: FC<IProps> = ({ title, forModal, onClick, disabled }) => {
  return (
    <button
      type="button"
      className={`home-page-red-button ${
        forModal ? "home-page-red-button_padding" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {title}
    </button>
  )
}
